<template>

  <div class="bg">
    <div class="share" v-if="shareIsShow">
      <img src="http://osswx-ahxmgk-com.oss-cn-hangzhou.aliyuncs.com/yun/uploads/image/2020/11/13/4dca18d4cf8ce19a02052ae524818457.png" width="100%">
    </div>
  <div class="body">
    <div class="content">
      <div class="title">
        <router-link :to="{name: 'Index'}"><span>〈</span></router-link>
        分享抽奖
      </div>
      <div class="info">
        <div class="tit">信息登记</div>
         <van-form @submit="u_onSubmit" class="form">
        <div class="name">
          <van-field
          v-model="username"
          name="name"
          label="姓名"
          placeholder="请输入姓名"
          :rules="[{ required: true, message: '请输入姓名' }]"
        />
        <div class="img"><img src="http://osswx-ahxmgk-com.oss-cn-hangzhou.aliyuncs.com/yun/uploads/image/2020/12/03/9a5611b5d186f57d1db7eb2f187bfef2.png"></div>
        </div>
        <div class="phone">
          <van-field
          v-model="mobile"
          type="number"
          name="mobile"
          label="手机号"
          placeholder="请输入手机号"
          :length="11"
          :rules="[{ validator, message: '请输入正确手机号' }]"
        />
         <div class="img"><img src="http://osswx-ahxmgk-com.oss-cn-hangzhou.aliyuncs.com/yun/uploads/image/2020/12/03/b4943cc2dc9886874e858b866a5f9b5c.png"></div>
        </div>
        
        <div style="margin: 16px;">
          <van-button block type="primary" native-type="submit" class="button">
            提交
          </van-button>
        </div>
      </van-form>
      </div>
      <div class="rule">
        <p>提示：如实填写姓名、手机号码并转发此链接到微信朋友圈或群聊，截图保存后即可获得1次“大奖豪礼”抽奖资格（礼品包括华为手机、智能手表、蓝牙耳机等）,以上个人信息仅作为领奖凭证使用，将为您严格保密。</p>
        <div style="width: 40%;margin: auto; overflow: hidden;">
          <div style="float: left;width: 45%"><img src="http://osswx-ahxmgk-com.oss-cn-hangzhou.aliyuncs.com/yun/uploads/image/2020/12/08/d3abbdd318423957cc115dbe2e782ae5.jpg" width="100%"></div>
          <div style="float: right;width: 45%"><img src="http://osswx-ahxmgk-com.oss-cn-hangzhou.aliyuncs.com/yun/uploads/image/2020/12/10/6d772d09e1f7a6a400344380c1e1dc62.png" width="100%"></div>
          
          
        </div>
      </div>
      <p style="text-align: center;line-height: 2em">扫码挑战有奖问答</p>
    </div>
  </div>
  </div>
	
</template>
<script>
import { getUserInfo,setUserInfo } from '@/api/user'
import { Toast } from 'vant'

export default {
    data() {
        return {
            info: this.$store.state.acc,
            user: this.$store.state.user,
            username:'',
            mobile:'',
            shareIsShow:false
        }
    },
    created(e) {
    	
    },
    methods: {
    	u_onSubmit(values){
        Toast('加载中');

        setUserInfo(values).then(res=>{
              // setToken(res.access_token)
              this.$store.commit('SET_USER', res.user)
              getUserInfo().then(res=>{
              this.$store.commit('SET_USER', res)
              Toast.clear()
              this.$dialog.confirm({
                message: '提交信息成功！',
                confirmButtonText:'去分享'
              }).then(() => {
                this.shareIsShow = true
                //datiShare()
                // on confirm
              }).catch(() => {
                // on cancel
              });
               //this.onSubmit()
              })
            })
      },
     
    }
}
</script>
<style>
  .bg{
    background: #eee;
  }
  .body{
    width: 100%;
    height: 100vh;
    background: url(http://osswx-ahxmgk-com.oss-cn-hangzhou.aliyuncs.com/yun/uploads/image/2020/12/03/07a34d3abeb6e5fb63b3587023a8799c.png) no-repeat center top;

  }
  .content {
    width: 100%;
    height: 100vh;
    background: url(http://osswx-ahxmgk-com.oss-cn-hangzhou.aliyuncs.com/yun/uploads/image/2020/12/03/b0ea8f4227de4a64db0532da08b8d47d.png) no-repeat center bottom;
    background-size: 100% auto;

  }
  .content .title{
    line-height: 3em;
    text-align: center;
    color: #fff;
    font-size: 1.6em;
    border-bottom: 1px solid #134de1;
    text-indent: -1em;
  }
  .content .title span{
    float: left;
    font-size: 1em;
    color: #134de1;
    text-indent: 0em;
  }
  .info{
    width: 80%;
    margin: auto;
    margin-top: 10vh;
    border-radius: 10px;
    overflow: hidden;
    padding: 5vh 2vh;
    background: #fff;
  }
  .tit{
    font-size: 1.2em;
    line-height: 2em;
    font-weight: bold;
    text-indent: 1em;
  }
  .img img{
    width: 100%;
  }
  .name , .phone{
    position: relative;
  }
  .name .img{
    width: 30px;
    position: absolute;
    right: 0;
    bottom: 10px;
  }
  .phone .img{
  width: 30px;
  position: absolute;
    right: 0;
    bottom: 10px;
  }
  .button{
    background: url(http://osswx-ahxmgk-com.oss-cn-hangzhou.aliyuncs.com/yun/uploads/image/2020/12/03/0e6c3fdf9fb377b3683e33241dd2812d.png);
    border: none;
    background-size: 100% 100%;
    width: 150px;
    margin: auto;
    padding-bottom: 8px; 
  }
  .rule{
    
    font-size: 1em;
    line-height: 1.5em;
    width: 80%;
    margin: auto;
    padding-top: 30px;
  }
  .share{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 30;
    background: rgba(0,0,0,0.5);
  }


</style>
